module.exports = __webpack_public_path__ + "img/signal-4.d56d2cc3.svg";